function getType(context) {
  return context.$route.path.includes('routecontrols') ? 'tc' : 'site';
}

const privs = {
  site: 'pr_site',
  tc: 'pr_tc'
};

const overviewUrls = {
  site: '/sites/reporttypes/{type_id}',
  tc: '/routecontrols/reporttypes/{type_id}'
};

const urls = {
  site: '/sites/reporttypes/{type_id}/lines',
  tc: '/routecontrols/reporttypes/{type_id}/lines'
};

export default {
  priv(context) {
    return privs[getType(context)];
  },
  detailTitle: '',
  deleteTitle: 'dit item',
  overviewUrl(context) {
    return overviewUrls[getType(context)];
  },
  url(context) {
    return urls[getType(context)];
  },
  apiUrl: '/siteinfos/{type_id}/lines/',
  newRecord: {
    site: false
  }
};
